export class GallerySearchCustom {
    layerClass = 'lity-gallery';
    isOpen = false;

    // staff
    figcaption;

    body;
    share;

    constructor() {
        this.init();
    }

    init() {
        let hash = window.location.hash;
        if (hash) {
            if ( hash.indexOf('#page=') === 0 ) {
                return
            } else if ( $("#galleryPhotoHolder").length ) {
                hash = hash.replace('#card_','/bb3content/photogallery/');
            } else if ( $("#galleryVideoHolder").length ) {
                hash = hash.replace('#card_','/bb3content/videogallery/');
            } else { return }
        } else { return }
        $.ajax({
            url: hash,
            method: 'GET',
        })
            .done((res) => {
                this.onClick(res);
                this.bindEvents();
            })
            .fail((err) => {
                console.debug('Gallery search custom Error ', err);
            });

        this.body = $('body');
        this.share = $('.author-card .share-tool').eq(0).clone(true);
    }

    bindEvents() {
        $(document).on('lity:remove', (layer) => this.onRemove(layer));
    }

    onClick($layer) {
        const datahtml = $layer;
        this.isOpen = true;

        let stringURL = window.location.href;
        const stringURLwithoutHash = stringURL.substr(0,stringURL.indexOf('#'));
        stringURL = $stringURL.replace('#','%23');
        const sharehtml = this.share.html();
        this.share.html(sharehtml.replace(new RegExp(stringURLwithoutHash, "g"), stringURL));
        $body.addClass('gallery--active');

        const lightbox = lity();
        lightbox($(datahtml).find(".oop-link").attr("href"));
        $(".lity")
            .addClass(this.layerClass)
            .find('.lity-container')
            .append(
                '<div class="lity-caption"><div class="figcaption">' + $(datahtml).find(".oop-link").html() + '</div></div>',
                this.share);
    }

    onRemove(layer) {
        if (this.isOpen) {
            $body.removeClass('gallery--active');
            layer.removeClass(this.layerClass);
            this.isOpen = false;
        }
    }
}
